export const UPDATE_FORM = 'UPDATE_FORM';
export const UPDATE_WORK_STUDY_DETAILS = 'UPDATE_WORK_STUDY_DETAILS';